import { payablesEn, payablesTh } from './payables-locales'

export const th = {
  ...payablesTh,
  app: { name: 'Accounting', description: 'ลูกค้า ใบแจ้งหนี้ และลูกหนี้ค้างชำระ' },
  nav: {
    overview: 'ภาพรวม',
    invoices: 'ใบแจ้งหนี้',
    payments: 'รับชำระ',
    billingNotes: 'ใบวางบิล',
    creditNotes: 'ใบลดหนี้',
    customerReceipts: 'ใบเสร็จใส่ชื่อลูกค้า',
    customers: 'คู่ค้า',
    receivables: 'ฝั่งรับ',
    settings: 'ข้อมูลหลัก',
    reports: 'รายงาน',
  },
  customer: {
    title: 'คู่ค้า',
    plural: 'คู่ค้า',
    create: 'เพิ่มคู่ค้า',
    fields: {
      code: 'รหัส',
      name: 'ชื่อ',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
      branch: 'สาขา',
      address: 'ที่อยู่ (เลขที่ อาคาร ถนน)',
      province: 'ตำบล อำเภอ จังหวัด',
      district: 'อำเภอ / เขต',
      subdistrict: 'ตำบล / แขวง',
      postcode: 'รหัสไปรษณีย์',
      contactName: 'ผู้ติดต่อ',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      creditDays: 'เครดิต (วัน)',
      isCustomer: 'ลูกค้า',
      isVendor: 'ผู้ขาย',
      bank: 'ธนาคาร',
      bankAccount: 'เลขบัญชี',
      bankAccountName: 'ชื่อบัญชี',
      payees: 'บัญชีอื่น',
      defaultWhtRate: 'หัก ณ ที่จ่ายปกติ (%)',
      status: 'สถานะ',
      notes: 'หมายเหตุ',
    },
    options: { status: { active: 'ใช้งาน', inactive: 'ระงับ' } },
    sections: {
      main: 'ข้อมูลคู่ค้า',
      roles: 'เป็น',
      address: 'ที่อยู่ออกใบกำกับภาษี',
      contact: 'การติดต่อ',
      vendor: 'การจ่ายเงิน (ผู้ขาย)',
      other: 'หมายเหตุ',
    },
    headOffice: 'สำนักงานใหญ่',
    /** A supplier's bank accounts, the main one first (BankAccounts) */
    accounts: {
      title: 'บัญชีธนาคาร',
      hint: 'บัญชีแรกเป็นบัญชีหลักที่โอนให้ตามปกติ บัญชีอื่น เช่น บัญชีคนขับรถร่วม เลือกได้ตอนจ่าย ฝ่ายจัดรถเลือกได้อย่างเดียวตอนขอเบิกล่วงหน้า เห็นแค่เลข 4 ตัวท้าย',
      main: 'บัญชีหลัก',
      makeMain: 'ตั้งเป็นบัญชีหลัก',
      add: 'เพิ่มบัญชี',
      none: 'ยังไม่มีบัญชีธนาคาร',
      name: 'ชื่อบัญชี',
      copy: 'คัดลอกเลขบัญชี',
      copied: 'คัดลอกแล้ว',
      taken: 'มีบัญชีเลขนี้แล้ว',
    },
    /** What a document's partner is missing for it to print (PartnerField) */
    gaps: {
      address: 'ที่อยู่',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
      warning: 'คู่ค้านี้ยังไม่มี{{what}} {{document}}จะพิมพ์ออกมาโดยไม่มีข้อมูลนี้',
      add: 'เพิ่มในข้อมูลคู่ค้า',
      certificate: 'หนังสือรับรองการหักภาษี ณ ที่จ่าย (50 ทวิ)',
    },
  },
  invoice: {
    title: 'ใบแจ้งหนี้',
    plural: 'ใบแจ้งหนี้',
    create: 'สร้างใบแจ้งหนี้',
    documentTitle: 'ใบแจ้งหนี้ / ใบกำกับภาษี',
    fields: {
      number: 'เลขที่',
      customerId: 'ลูกค้า',
      issueDate: 'วันที่',
      dueDate: 'ครบกำหนด',
      lines: 'รายการ',
      vatRate: 'ภาษีมูลค่าเพิ่ม (%)',
      whtRate: 'หัก ณ ที่จ่าย (%)',
      notes: 'หมายเหตุ',
      status: 'สถานะ',
      subtotal: 'รวมเป็นเงิน',
      vat: 'ภาษีมูลค่าเพิ่ม',
      total: 'จำนวนเงินรวมทั้งสิ้น',
      paidAmount: 'ชำระแล้ว',
      credited: 'ลดหนี้',
      outstanding: 'ค้างชำระ',
      paidAt: 'ชำระครบเมื่อ',
      opening: 'ยกยอดมา',
      paymentIds: 'ใบรับเงิน',
      billingNoteId: 'ใบวางบิล',
      signing: 'ลูกค้าเซ็นรับ',
    },
    options: { status: { draft: 'ร่าง', issued: 'ยังไม่ชำระ', partial: 'ชำระบางส่วน', paid: 'ชำระแล้ว', cancelled: 'ยกเลิก' } },
    sections: { main: 'ข้อมูลเอกสาร', lines: 'รายการ', totals: 'ภาษี', other: 'หมายเหตุ' },
    actions: { pay: 'บันทึกรับชำระ', paySelected: 'รับชำระ ({{count}})', billSelected: 'วางบิล ({{count}})', applyDeposit: 'ใช้กับใบนี้' },
    deposits: {
      title: 'เงินรับล่วงหน้าที่ยังไม่ได้ใช้',
      applied: 'ใช้เงิน {{amount}} บาท จาก {{number}} แล้ว',
    },
    line: {
      description: 'รายละเอียด',
      qty: 'จำนวน',
      unitPrice: 'ราคาต่อหน่วย',
      amount: 'จำนวนเงิน',
      add: 'เพิ่มรายการ',
    },
    totals: {
      subtotal: 'รวมเป็นเงิน',
      vat: 'ภาษีมูลค่าเพิ่ม {{rate}}%',
      total: 'จำนวนเงินรวมทั้งสิ้น',
      wht: 'หัก ณ ที่จ่าย {{rate}}%',
      net: 'ยอดชำระสุทธิ',
      inWords: 'ตัวอักษร',
    },
    print: {
      /** A freight invoice: one a month, handed over for collection too */
      title: 'ใบแจ้งหนี้ / ใบวางบิล',
      original: 'ต้นฉบับ',
      copy: 'สำเนา',
      billTo: 'ลูกค้า',
      receivedBy: 'ผู้รับวางบิล',
      authorized: 'ผู้มีอำนาจลงนาม',
      date: 'วันที่',
    },
  },
  creditNote: {
    title: 'ใบลดหนี้',
    plural: 'ใบลดหนี้',
    create: 'ออกใบลดหนี้',
    fields: {
      number: 'เลขที่',
      invoiceId: 'ใบแจ้งหนี้',
      customerId: 'ลูกค้า',
      issueDate: 'วันที่',
      amount: 'ลดหนี้',
      reason: 'เหตุผล',
      line: 'รายการที่แก้',
      released: 'ย้ายเป็นเงินรับล่วงหน้า',
      status: 'สถานะ',
    },
    options: { status: { draft: 'ร่าง', issued: 'ออกแล้ว', cancelled: 'ยกเลิก' } },
    sections: { main: 'ใบลดหนี้' },
    issue: 'ออกใบลดหนี้',
    issueTitle: 'ออกใบลดหนี้ ใบแจ้งหนี้ {{number}}',
    issueHint: 'ใบแจ้งหนี้เดิมยังอยู่ ยอดค้างลดลงตามใบลดหนี้ ถ้าลูกค้าจ่ายไปแล้วเกินยอดใหม่ ส่วนเกินจะเป็นเงินรับล่วงหน้าของลูกค้า ใช้หักบิลหน้าได้',
    max: 'ลดได้ไม่เกิน {{amount}} บาท',
    issued: 'ออกใบลดหนี้ {{number}} แล้ว',
    released: 'ย้าย {{amount}} บาทเป็นเงินรับล่วงหน้าของลูกค้า ใช้หักบิลหน้าได้',
    print: {
      title: 'ใบลดหนี้',
      taxTitle: 'ใบลดหนี้ / ใบกำกับภาษี',
      forInvoice: 'อ้างถึงใบแจ้งหนี้',
      invoiceDate: 'ลงวันที่',
      item: 'รายการ',
      lowered: 'ลดราคาตามใบแจ้งหนี้ {{number}}',
      original: 'มูลค่าตามใบแจ้งหนี้เดิม',
      corrected: 'มูลค่าที่ถูกต้อง',
      difference: 'ผลต่าง',
      total: 'รวมลดหนี้',
      issuer: 'ผู้ออกเอกสาร',
      receiver: 'ผู้รับเอกสาร',
    },
  },
  customerReceipt: {
    title: 'ใบเสร็จใส่ชื่อลูกค้า',
    plural: 'ใบเสร็จใส่ชื่อลูกค้า',
    create: 'ออกใบเสร็จใส่ชื่อลูกค้า',
    /** Printed: a receipt like the counter's, never a tax invoice */
    documentTitle: 'ใบเสร็จรับเงิน',
    fields: {
      number: 'เลขที่',
      issueDate: 'วันที่ออก',
      receiptId: 'ออกแทนใบเสร็จ',
      paidOn: 'วันที่รับเงิน',
      branchId: 'สาขาที่รับเงิน',
      payerName: 'ผู้ชำระตามใบเสร็จเดิม',
      partyType: 'ประเภท',
      name: 'ชื่อลูกค้า',
      nameReason: 'เหตุที่ชื่อไม่ตรงกับผู้ชำระ',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
      branch: 'สาขา (00000 = สำนักงานใหญ่)',
      address: 'ที่อยู่ (เลขที่ อาคาร ถนน)',
      province: 'ตำบล อำเภอ จังหวัด',
      district: 'อำเภอ / เขต',
      subdistrict: 'ตำบล / แขวง',
      postcode: 'รหัสไปรษณีย์',
      recalled: 'เรียกใบเสร็จเดิมคืนแล้ว',
      notRecalledNote: 'เหตุที่เรียกคืนไม่ได้',
      receivedBy: 'ผู้รับเงิน',
      selfIssued: 'ลูกค้าออกเอง',
      lines: 'รายการ',
      amount: 'ค่าขนส่ง',
      whtAmount: 'หัก ณ ที่จ่าย',
      received: 'รับเงินสุทธิ',
      priorMonth: 'รับเงินเดือนก่อน',
      status: 'สถานะ',
      notes: 'หมายเหตุ',
    },
    options: { status: { draft: 'ร่าง', issued: 'ออกแล้ว', cancelled: 'ยกเลิก' } },
    sections: { main: 'ใบเสร็จเดิม', customer: 'ลูกค้า', address: 'ที่อยู่', recall: 'ใบเสร็จเดิมของลูกค้า', other: 'หมายเหตุ' },
    late: 'ลูกค้าจ่ายเงินเมื่อ {{date}} เกิน 6 เดือนแล้ว ยังออกได้ ตรวจให้แน่ใจว่าคนที่ขอเป็นผู้ชำระจริง',
    priorMonth: 'รับเงินเดือนก่อน: ส่งให้สำนักงานบัญชีกับเอกสารของเดือนที่ออก แนบคู่กับใบเสร็จเดิม ไม่ลงรายได้ซ้ำ',
    side: { sender: 'ส่วนผู้ส่ง', receiver: 'ส่วนผู้รับ' },
    print: {
      receivedFrom: 'ได้รับเงินจาก',
      line: 'ค่าขนส่ง บิล {{number}}',
      replaces: 'ออกแทนใบเสร็จรับเงินเลขที่ {{number}} ลงวันที่ {{date}}',
      receiver: 'ผู้รับเงิน',
    },
  },
  billingNote: {
    title: 'ใบวางบิล',
    plural: 'ใบวางบิล',
    create: 'สร้างใบวางบิล',
    documentTitle: 'ใบวางบิล / ใบแจ้งหนี้รวม',
    fields: {
      number: 'เลขที่',
      billedOn: 'วันที่วางบิล',
      customerId: 'ลูกค้า',
      dueDate: 'นัดชำระ',
      invoiceIds: 'ใบแจ้งหนี้',
      amount: 'ยอดรวม',
      receivedBy: 'ผู้รับวางบิล',
      receivedOn: 'วันที่รับวางบิล',
      notes: 'หมายเหตุ',
      signing: 'ลูกค้าเซ็นรับ',
    },
    sections: { main: 'ข้อมูลใบวางบิล', invoices: 'ใบแจ้งหนี้ที่วางบิล', received: 'การรับวางบิล', other: 'หมายเหตุ' },
    pick: {
      none: 'ลูกค้ารายนี้ไม่มีใบแจ้งหนี้ค้างที่ยังไม่ได้วางบิล',
      onOther: 'อยู่ในใบวางบิล {{number}}',
      selected: 'เลือก {{count}} ใบ รวม {{amount}} บาท',
      all: 'เลือกทั้งหมด',
    },
    outstanding: 'ค้างชำระ',
    pay: 'รับชำระตามใบวางบิล',
    print: { biller: 'ผู้วางบิล', receiver: 'ผู้รับวางบิล', payOn: 'นัดชำระวันที่' },
  },
  payment: {
    title: 'ใบรับเงิน',
    plural: 'ใบรับเงิน',
    create: 'รับชำระ',
    documentTitle: 'ใบรับเงิน',
    fields: {
      number: 'เลขที่',
      receivedOn: 'วันที่รับเงิน',
      customerId: 'ลูกค้า',
      billingNoteId: 'ชำระตามใบวางบิล',
      payments: 'รายการรับเงิน',
      allocations: 'ตัดชำระใบแจ้งหนี้',
      whtAmount: 'ภาษีหัก ณ ที่จ่าย',
      whtCertNo: 'เลขที่หนังสือรับรอง (50 ทวิ)',
      whtCertFileId: 'ไฟล์หนังสือรับรอง',
      writeOff: 'ส่วนต่างที่ตัดทิ้ง',
      writeOffReason: 'เหตุผลส่วนต่าง',
      received: 'รับเงิน',
      settled: 'ตัดชำระได้',
      allocated: 'ตัดชำระแล้ว',
      unallocated: 'คงเหลือ (ยังไม่ตัดชำระ)',
      notes: 'หมายเหตุ',
      signing: 'ลูกค้าเซ็นรับ',
    },
    options: {
      method: { transfer: 'โอน', cash: 'เงินสด', cheque: 'เช็ค' },
    },
    sections: { main: 'ข้อมูลการรับเงิน', money: 'เงินที่ได้รับ', wht: 'หัก ณ ที่จ่าย', allocations: 'ตัดชำระใบแจ้งหนี้', other: 'หมายเหตุ' },
    money: {
      method: 'ช่องทาง',
      amount: 'จำนวนเงิน',
      reference: 'เลขอ้างอิง / เลขที่เช็ค',
      slip: 'สลิป / รูปเช็ค',
      slipNeeded: 'แนบรูปสลิปของยอดโอน',
      add: 'เพิ่มช่องทาง',
      remove: 'ลบรายการนี้',
    },
    allocate: {
      invoice: 'ใบแจ้งหนี้',
      dueDate: 'ครบกำหนด',
      total: 'ยอดใบแจ้งหนี้',
      outstanding: 'ค้างชำระ',
      amount: 'ตัดชำระ',
      auto: 'ตัดอัตโนมัติ (เก่าสุดก่อน)',
      clear: 'ล้าง',
      none: 'ลูกค้ารายนี้ไม่มีใบแจ้งหนี้ค้างชำระ',
      chooseCustomer: 'เลือกลูกค้าก่อน',
      overAllocated: 'ตัดชำระเกินยอดที่รับ {{amount}} บาท',
      overInvoice: 'ตัดเกินยอดค้างของใบนี้',
      leftover: 'คงเหลือ {{amount}} บาท จะเก็บเป็นเงินรับล่วงหน้าของลูกค้า',
      withholding: 'ลูกค้าหัก ณ ที่จ่ายตามใบแจ้งหนี้ ({{amount}} บาท)',
    },
    done: { saved: 'บันทึกใบรับเงิน {{number}} แล้ว' },
    /** Taking an invoice's payment in one step (ReceiveDialog) */
    receive: {
      title: 'รับชำระ',
      invoices: '{{count}} ใบ',
      due: 'ยอดที่ต้องรับ',
      owed: 'ค้างชำระ {{amount}}',
      withheld: 'ลูกค้าหัก ณ ที่จ่าย {{amount}} บาท',
      received: { transfer: 'ยอดโอน', cash: 'รับเงินมา', cheque: 'ยอดเช็ค' },
      short: 'ยังค้างอีก',
      over: 'เกินมา เก็บเป็นเงินรับล่วงหน้าของลูกค้า',
      writeOff: 'ถือว่าครบ: ตัดส่วนต่าง {{amount}} บาทเป็นค่าธรรมเนียมโอน / ปัดเศษ',
      writeOffReason: 'ค่าธรรมเนียมโอน / ปัดเศษ',
      confirm: 'รับเงินและออกใบรับเงิน',
      done: 'ออกใบรับเงิน {{number}} แล้ว',
      detailed: 'รับชำระแบบละเอียด',
    },
    print: { receivedFrom: 'ได้รับเงินจาก', forInvoices: 'ชำระค่า', receiver: 'ผู้รับเงิน', payer: 'ผู้จ่ายเงิน' },
  },
  /** The customer's line on an issued document, in its signing box (`SigningBox`; the box's own words are `signing`) */
  signing: {
    heading: 'ลูกค้าเซ็นรับ',
    signed: 'ลูกค้าเซ็นรับแล้ว',
    intro: 'ให้ลูกค้าตรวจ{{document}} เลขที่ {{number}} แล้วเซ็นรับ',
    statement: 'ข้าพเจ้า {{name}} ได้รับ{{document}} เลขที่ {{number}} แล้ว',
  },
  overview: {
    title: 'ภาพรวม',
    outstanding: 'ยอดค้างรับทั้งหมด',
    overdue: 'เกินกำหนดชำระ',
    aging: 'ยอดค้างรับตามอายุหนี้',
    recent: 'ใบแจ้งหนี้ล่าสุด',
    viewAll: 'ดูทั้งหมด',
  },
  reports: {
    title: 'รายงาน',
    aging: 'อายุลูกหนี้',
    agingDescription: 'ยอดค้างชำระแยกตามช่วงอายุหนี้ของลูกค้าแต่ละราย',
    asOf: 'ณ วันที่',
    current: 'ยังไม่ถึงกำหนด',
    d30: '1–30 วัน',
    d60: '31–60 วัน',
    d90: '61–90 วัน',
    over90: 'เกิน 90 วัน',
    totalDue: 'รวมค้างชำระ',
    whtReceived: 'ภาษีถูกหัก ณ ที่จ่าย',
    whtReceivedHint: 'ภาษีที่ลูกค้าหักจากค่าขนส่งและใบแจ้งหนี้ พร้อมใบ 50 ทวิ ใช้เป็นเครดิตภาษีของบริษัท',
    whtMonth: 'รายเดือน',
    whtPending: 'ยังไม่ได้รับ 50 ทวิ',
    whtCol: {
      date: 'วันที่',
      number: 'เอกสาร',
      source: 'จาก',
      payer: 'ผู้หัก',
      taxId: 'เลขผู้เสียภาษี',
      income: 'ยอดที่ถูกหัก',
      tax: 'ภาษีที่ถูกหัก',
      certNo: 'เลขที่ 50 ทวิ',
      cert: 'ใบ 50 ทวิ',
    },
    whtSource: { receipt: 'ใบเสร็จหน้าร้าน', refund: 'คืนภาษีภายหลัง', payment: 'รับชำระใบแจ้งหนี้' },
    whtCert: { received: 'ได้รับแล้ว', pending: 'ยังไม่ได้รับ' },
    whtTotal: 'ภาษีถูกหักรวม',
    whtCount: 'จำนวนรายการ',
    whtMissing: 'ยังไม่ได้รับ 50 ทวิ',
  },
} as const

export const en = {
  ...payablesEn,
  app: { name: 'Accounting', description: 'Customers, invoices and receivables' },
  nav: {
    overview: 'Overview',
    invoices: 'Invoices',
    payments: 'Payments',
    billingNotes: 'Billing notes',
    creditNotes: 'Credit notes',
    customerReceipts: 'Receipts in customers’ names',
    customers: 'Partners',
    receivables: 'Receivables',
    settings: 'Master data',
    reports: 'Reports',
  },
  customer: {
    title: 'Partner',
    plural: 'Partners',
    create: 'Add partner',
    fields: {
      code: 'Code',
      name: 'Name',
      taxId: 'Tax ID',
      branch: 'Branch',
      address: 'Address (number, building, road)',
      province: 'Subdistrict, district, province',
      district: 'District',
      subdistrict: 'Subdistrict',
      postcode: 'Postcode',
      contactName: 'Contact',
      phone: 'Phone',
      email: 'Email',
      creditDays: 'Credit (days)',
      isCustomer: 'Customer',
      isVendor: 'Supplier',
      bank: 'Bank',
      bankAccount: 'Account no.',
      bankAccountName: 'Account name',
      payees: 'Other accounts',
      defaultWhtRate: 'Usual withholding (%)',
      status: 'Status',
      notes: 'Notes',
    },
    options: { status: { active: 'Active', inactive: 'On hold' } },
    sections: {
      main: 'Partner',
      roles: 'Is a',
      address: 'Tax invoice address',
      contact: 'Contact',
      vendor: 'Paying them (supplier)',
      other: 'Notes',
    },
    headOffice: 'Head office',
    accounts: {
      title: 'Bank accounts',
      hint: 'The first is the main account, paid into as a rule. Others, a contract driver’s for one, can be picked when paying; dispatch only picks one for an advance and sees its last 4 digits',
      main: 'Main',
      makeMain: 'Make it the main account',
      add: 'Add an account',
      none: 'No bank account yet',
      name: 'Account name',
      copy: 'Copy the account number',
      copied: 'Copied',
      taken: 'This account is already there',
    },
    gaps: {
      address: 'address',
      taxId: 'tax ID',
      warning: 'This partner has no {{what}} yet: the {{document}} will be printed without it.',
      add: 'Add it to the partner',
      certificate: 'withholding tax certificate (50 bis)',
    },
  },
  invoice: {
    title: 'Invoice',
    plural: 'Invoices',
    create: 'New invoice',
    documentTitle: 'Invoice / Tax invoice',
    fields: {
      number: 'No.',
      customerId: 'Customer',
      issueDate: 'Date',
      dueDate: 'Due',
      lines: 'Lines',
      vatRate: 'VAT (%)',
      whtRate: 'Withholding (%)',
      notes: 'Notes',
      status: 'Status',
      subtotal: 'Subtotal',
      vat: 'VAT',
      total: 'Total',
      paidAmount: 'Paid',
      credited: 'Credited',
      outstanding: 'Outstanding',
      paidAt: 'Paid in full at',
      opening: 'Brought forward',
      paymentIds: 'Payments',
      billingNoteId: 'Billing note',
      signing: 'Customer signed',
    },
    options: { status: { draft: 'Draft', issued: 'Unpaid', partial: 'Partly paid', paid: 'Paid', cancelled: 'Cancelled' } },
    sections: { main: 'Document', lines: 'Lines', totals: 'Tax', other: 'Notes' },
    actions: {
      pay: 'Record payment',
      paySelected: 'Receive payment ({{count}})',
      billSelected: 'Billing note ({{count}})',
      applyDeposit: 'Apply to this invoice',
    },
    deposits: {
      title: 'Unused money paid ahead',
      applied: '{{amount}} THB from {{number}} applied',
    },
    line: {
      description: 'Description',
      qty: 'Qty',
      unitPrice: 'Unit price',
      amount: 'Amount',
      add: 'Add line',
    },
    totals: {
      subtotal: 'Subtotal',
      vat: 'VAT {{rate}}%',
      total: 'Total',
      wht: 'Withholding {{rate}}%',
      net: 'Net payable',
      inWords: 'In words',
    },
    print: {
      title: 'Invoice / Billing note',
      original: 'Original',
      copy: 'Copy',
      billTo: 'Bill to',
      receivedBy: 'Received by',
      authorized: 'Authorized signature',
      date: 'Date',
    },
  },
  creditNote: {
    title: 'Credit note',
    plural: 'Credit notes',
    create: 'Issue a credit note',
    fields: {
      number: 'No.',
      invoiceId: 'Invoice',
      customerId: 'Customer',
      issueDate: 'Date',
      amount: 'Credit',
      reason: 'Reason',
      line: 'Line corrected',
      released: 'Moved to the advance',
      status: 'Status',
    },
    options: { status: { draft: 'Draft', issued: 'Issued', cancelled: 'Cancelled' } },
    sections: { main: 'Credit note' },
    issue: 'Issue a credit note',
    issueTitle: 'Credit note for invoice {{number}}',
    issueHint:
      "The invoice stands as issued; what it still owes goes down by the note. Paid already beyond the new amount, the excess becomes the customer's advance for the next invoice",
    max: 'No more than {{amount}} THB',
    issued: 'Credit note {{number}} issued',
    released: "{{amount}} THB moved to the customer's advance, for the next invoice",
    print: {
      title: 'Credit note',
      taxTitle: 'Credit note / Tax invoice',
      forInvoice: 'For invoice',
      invoiceDate: 'Dated',
      item: 'Description',
      lowered: 'Price lowered on invoice {{number}}',
      original: 'Invoice amount',
      corrected: 'Correct amount',
      difference: 'Difference',
      total: 'Total credited',
      issuer: 'Issued by',
      receiver: 'Received by',
    },
  },
  customerReceipt: {
    title: 'Receipt in the customer’s name',
    plural: 'Receipts in customers’ names',
    create: 'Issue a receipt in the customer’s name',
    documentTitle: 'Receipt',
    fields: {
      number: 'No.',
      issueDate: 'Issued on',
      receiptId: 'In place of receipt',
      paidOn: 'Paid on',
      branchId: 'Branch that took the money',
      payerName: 'Payer on the original receipt',
      partyType: 'Type',
      name: 'Customer name',
      nameReason: 'Why the name is not the payer’s',
      taxId: 'Tax ID',
      branch: 'Branch (00000 = head office)',
      address: 'Address (number, building, road)',
      province: 'Subdistrict, district, province',
      district: 'District',
      subdistrict: 'Subdistrict',
      postcode: 'Postcode',
      recalled: 'Original receipt handed back',
      notRecalledNote: 'Why it was not handed back',
      receivedBy: 'Received by',
      selfIssued: 'Issued by the customer',
      lines: 'Lines',
      amount: 'Freight',
      whtAmount: 'Withheld',
      received: 'Net received',
      priorMonth: 'Paid in an earlier month',
      status: 'Status',
      notes: 'Notes',
    },
    options: { status: { draft: 'Draft', issued: 'Issued', cancelled: 'Cancelled' } },
    sections: {
      main: 'Original receipt',
      customer: 'Customer',
      address: 'Address',
      recall: 'The customer’s original receipt',
      other: 'Notes',
    },
    late: 'The customer paid on {{date}}, more than 6 months ago. It can still be issued: make sure whoever asks is the one who paid',
    priorMonth:
      'Paid in an earlier month: send it to the accounting firm with the papers of the month it is issued, with the original receipt, not as new income',
    side: { sender: 'sender’s part', receiver: 'receiver’s part' },
    print: {
      receivedFrom: 'Received from',
      line: 'Freight, waybill {{number}}',
      replaces: 'In place of receipt no. {{number}} dated {{date}}',
      receiver: 'Received by',
    },
  },
  billingNote: {
    title: 'Billing note',
    plural: 'Billing notes',
    create: 'New billing note',
    documentTitle: 'Billing note',
    fields: {
      number: 'No.',
      billedOn: 'Billed on',
      customerId: 'Customer',
      dueDate: 'To be paid on',
      invoiceIds: 'Invoices',
      amount: 'Total',
      receivedBy: 'Received by',
      receivedOn: 'Received on',
      notes: 'Notes',
      signing: 'Customer signed',
    },
    sections: { main: 'Billing note', invoices: 'Invoices billed', received: 'Receipt by the customer', other: 'Notes' },
    pick: {
      none: 'This customer has no outstanding invoices that are not billed yet',
      onOther: 'On billing note {{number}}',
      selected: '{{count}} selected, {{amount}} THB',
      all: 'Select all',
    },
    outstanding: 'Outstanding',
    pay: 'Receive payment for this note',
    print: { biller: 'Billed by', receiver: 'Received by', payOn: 'To be paid on' },
  },
  payment: {
    title: 'Payment',
    plural: 'Payments',
    create: 'Receive payment',
    documentTitle: 'Receipt',
    fields: {
      number: 'No.',
      receivedOn: 'Received on',
      customerId: 'Customer',
      billingNoteId: 'For billing note',
      payments: 'Money received',
      allocations: 'Invoices settled',
      whtAmount: 'Withholding tax',
      whtCertNo: 'Certificate no. (50 bis)',
      whtCertFileId: 'Certificate file',
      writeOff: 'Written off',
      writeOffReason: 'Reason',
      received: 'Received',
      settled: 'Settles',
      allocated: 'Allocated',
      unallocated: 'Unallocated',
      notes: 'Notes',
      signing: 'Customer signed',
    },
    options: {
      method: { transfer: 'Transfer', cash: 'Cash', cheque: 'Cheque' },
    },
    sections: { main: 'Payment', money: 'Money received', wht: 'Withholding tax', allocations: 'Invoices settled', other: 'Notes' },
    money: {
      method: 'Method',
      amount: 'Amount',
      reference: 'Reference / cheque no.',
      slip: 'Slip / cheque photo',
      slipNeeded: 'Attach the photo of the transfer slip',
      add: 'Add method',
      remove: 'Remove',
    },
    allocate: {
      invoice: 'Invoice',
      dueDate: 'Due',
      total: 'Invoice total',
      outstanding: 'Outstanding',
      amount: 'Settle',
      auto: 'Allocate oldest first',
      clear: 'Clear',
      none: 'This customer has no outstanding invoices',
      chooseCustomer: 'Choose a customer first',
      overAllocated: '{{amount}} THB more allocated than received',
      overInvoice: 'More than this invoice owes',
      leftover: "{{amount}} THB left is kept as the customer's advance",
      withholding: 'The customer withheld tax per the invoices ({{amount}} THB)',
    },
    done: { saved: 'Payment {{number}} saved' },
    receive: {
      title: 'Take payment',
      invoices: '{{count}} invoices',
      due: 'To receive',
      owed: 'Outstanding {{amount}}',
      withheld: 'The customer withholds {{amount}} THB',
      received: { transfer: 'Transferred', cash: 'Received', cheque: 'Cheque amount' },
      short: 'Still owed',
      over: "More than owed: kept as the customer's advance",
      writeOff: 'Count it as paid: write off {{amount}} THB (transfer fee / rounding)',
      writeOffReason: 'Transfer fee / rounding',
      confirm: 'Receive and issue the receipt',
      done: 'Receipt {{number}} issued',
      detailed: 'More options',
    },
    print: { receivedFrom: 'Received from', forInvoices: 'For', receiver: 'Received by', payer: 'Paid by' },
  },
  signing: {
    heading: 'Customer signs for it',
    signed: 'Signed for by the customer',
    intro: 'Let the customer check {{document}} {{number}}, then sign for it',
    statement: 'I, {{name}}, have received {{document}} {{number}}',
  },
  overview: {
    title: 'Overview',
    outstanding: 'Outstanding',
    overdue: 'Overdue',
    aging: 'Outstanding by age',
    recent: 'Latest invoices',
    viewAll: 'View all',
  },
  reports: {
    title: 'Reports',
    aging: 'Receivables aging',
    agingDescription: 'Outstanding balance per customer by age',
    asOf: 'As of',
    current: 'Not due',
    d30: '1–30 days',
    d60: '31–60 days',
    d90: '61–90 days',
    over90: 'Over 90 days',
    totalDue: 'Total due',
    whtReceived: 'Tax withheld from us',
    whtReceivedHint: "The tax customers withheld from freight and invoices, with their 50 Tawi: the company's tax credit",
    whtMonth: 'By month',
    whtPending: 'Awaiting 50 Tawi',
    whtCol: {
      date: 'Date',
      number: 'Document',
      source: 'From',
      payer: 'Withheld by',
      taxId: 'Tax ID',
      income: 'Withheld on',
      tax: 'Tax withheld',
      certNo: '50 Tawi no.',
      cert: '50 Tawi',
    },
    whtSource: { receipt: 'Counter receipt', refund: 'Given back later', payment: 'Invoice payment' },
    whtCert: { received: 'Received', pending: 'Not yet' },
    whtTotal: 'Tax withheld',
    whtCount: 'Entries',
    whtMissing: 'Awaiting 50 Tawi',
  },
} as const
